import { Controller } from "@hotwired/stimulus";

// Links the recovery summary bar to the table beneath it. Hovering a band of the bar highlights
// the rows it summarises, and hovering a row highlights its band — the bar is the headline, the
// table is the itemisation, and several rows share one band.
//
// Both sides carry a matching data-segment; nothing here knows the segment names, so adding a
// band or a row needs no change to this file.
export default class extends Controller {
  static targets = ["band", "row"];

  connect() {
    this.clear();
  }

  highlight(event) {
    const segment = event.currentTarget.dataset.segment;
    if (!segment) return;

    // Dim what isn't in the segment rather than colouring what is: the bands already carry meaning
    // through colour, so adding a highlight hue on top would compete with it.
    this.#eachElement((element) => {
      element.classList.toggle("opacity-30", element.dataset.segment !== segment);
    });
  }

  clear() {
    this.#eachElement((element) => element.classList.remove("opacity-30"));
  }

  #eachElement(callback) {
    [...this.bandTargets, ...this.rowTargets].forEach(callback);
  }
}
